import '../lessons/components/lesson_footer';
import '../lessons/components/lesson_item';
import '../lessons/components/questions_cta';
import './index.scss';
import 'components/summary_suggestions';
import LessonPlayer from 'components/lesson_player';

(function ($) {
  'use strict';

  LessonPlayer.start($('q-lesson-text-page'));
})(jQuery);
